function Alleles() {
  return <li className="bullet-item">The reference and alternative alleles</li>;
}

export default Alleles;
